import { createMigration } from './utils';

export const migrationTo9_181 = createMigration({
    migrateVideo(video) {
        return video.withMutations(map => {
            map.get('sceneGroups').forEach((sceneGroup, i) => {
                map.setIn(['sceneGroups', i], this.migrateSceneGroup(sceneGroup));
            });
            map.get('slides').forEach((scene, i) => {
                map.setIn(['slides', i], this.migrateScene(scene));
            });
            const template = map.get('template');
            map.set('template', this.migrateTemplate(template));
        });
    },
    migrateScene(scene) {
        return scene.withMutations(map => {
            let currentTransitionUrl = map.getIn(['customTransition', 'transitionUrl']) as string;
            if (!currentTransitionUrl) {
                return;
            }
            const aspectRatio = map.get('aspectRatio');
            if (aspectRatio === 'vertical') {
                if (currentTransitionUrl.includes('landscape')) {
                    currentTransitionUrl = currentTransitionUrl.replace('landscape', 'vertical');
                }
                if (currentTransitionUrl.includes('Landscape')) {
                    currentTransitionUrl = currentTransitionUrl.replace('Landscape', 'Vertical');
                }
            }
            else if (aspectRatio === 'square') {
                if (currentTransitionUrl.includes('landscape')) {
                    currentTransitionUrl = currentTransitionUrl.replace('landscape', 'square');
                }
                if (currentTransitionUrl.includes('Landscape')) {
                    currentTransitionUrl = currentTransitionUrl.replace('Landscape', 'Square');
                }
            }
            map.setIn(['customTransition', 'transitionUrl'], currentTransitionUrl);
        });
    },
});
